export default "__VITE_ASSET__eK2Sv2$g__"